import Cities from './Cities';

export default Cities;



// WEBPACK FOOTER //
// ./src/pages/Cities/index.ts